// Escape special regex characters to prevent injection
// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
export default function escapeRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
